import { useEffect, useReducer } from 'react';
import { getPinLockoutEnd } from 'utils/helpers/pinKeyCache.helpers';

// End of the user's active PIN lockout on this browser (epoch ms), re-evaluated when it expires.
// Call the returned refresh after an action that may have recorded a new lockout.
export const usePinLockout = (
  orgId: string | null | undefined,
  email: string | null | undefined,
): [lockedUntil: number | undefined, refresh: VoidFunction] => {
  const [, refresh] = useReducer((n: number) => n + 1, 0);
  const lockedUntil = email ? getPinLockoutEnd(orgId, email) : undefined;

  useEffect(() => {
    if (!lockedUntil) return;

    const timer = setTimeout(refresh, Math.max(lockedUntil - Date.now(), 0) + 50);
    return () => clearTimeout(timer);
  }, [lockedUntil]);

  return [lockedUntil, refresh];
};
